import axios from "axios";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { env } from "../../env";

const SchedulePopUp = ({customerId, ipData, visitTypeList, sendSchedulePopUpDataFromChild, sendVisitResponseDataFromChild}) => {
    const { t } = useTranslation();

    // boolean
    const [showDropDown, setShowDropDown] = useState(false);
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    // data
    const [visitType, setVisitType] = useState("");
    const [visitTypeId, setVisitTypeId] = useState("");
    
    const handleDropDown = (e, value) => {
        e.preventDefault();
        setShowDropDown(false);
        setVisitType(value.Title);
        setVisitTypeId(value.Id)
    };
    const hangleModalClose = (e) => {
        e.preventDefault();
        sendSchedulePopUpDataFromChild('start');
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsButtonLoading(true); 
        const baseUrl = env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');
        const headers = {
            "Accept" : "Application/json",
            "Content-Type" : "Application/json",
            "Authorization" : `Bearer ${token}`
        };

        await axios.post(baseUrl+`/api/Customer/StartCustomerVisit`, {
            "CustomerId" : customerId,
            "TypeOfVisit": visitType,
            "TypeOfVisitId": visitTypeId,
            "AddressLat": ipData.latitude,
            "AddressLong": ipData.longitude,
            "DeviceId": ipData.ip,
        }, { headers })
        .then((response) => {
            const myObject = {
                "visitType" : visitType,
                "visitTypeId" : visitTypeId,
                "visitId" : response.data.data[0].VisitId,
                "customerId" : customerId
            }
            localStorage.setItem("visit", JSON.stringify(myObject));
            setIsButtonLoading(false); 
            sendVisitResponseDataFromChild(myObject);
        }).catch((error) => {
            setIsButtonLoading(false); 
            console.log(error);
        });
    };

    return (
        <div className="fixed z-50 overflow-y-auto top-0 w-full left-0 h-full">
            <div className="flex items-center justify-center min-height-100vh pt-4 px-4 pb-20 text-center sm:block sm:p-0 h-full">
                <div className="fixed inset-0 transition-opacity">
                    <div className="absolute inset-0 bg-gray-900 opacity-75" />
                </div>
                <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
                <div className="inline-block align-center bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-lg w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                    <div className="bg-white py-4 px-4 sm:px-8 sm:py-8 space-y-2 sm:space-y-3">
                        <div className="flex justify-between">
                            <div className="font-semibold sm:text-lg capitalize">{ t('start customer visit')}</div>
                            <div className="cursor-pointer" onClick={(e) => (!isButtonLoading && hangleModalClose(e))}>
                                <img src="../../../assets/icons/modal-cross.svg" alt="cross" />
                            </div>
                        </div>
                        <div className="sm:flex sm:items-center text-sm space-y-1 sm:space-y-0">
                            <div className="sm:border sm:border-y-2 sm:border-l-2 sm:border-background-normal sm:p-2 sm:bg-blue-light capitalize sm:rounded-l-lg sm:w-40 sm:text-center">{ t('type of visit')}</div>
                            <div className="relative border border-l-2 sm:border-l-0 border-y-2 border-r-2 border-background-normal p-2 w-full rounded-l-lg sm:rounded-l-none rounded-r-lg">
                                <button type="button" onClick={(e) => setShowDropDown(!showDropDown)} className=" text-gray-dark w-full justify-between font-normal inline-flex items-center">
                                    <span className={(visitType ? "text-black" : "text-gray-dark") + " capitalize mr-1 text-sm"}>{visitType.length > 0 ? t(visitType) : t('select visit type')}</span>
                                    <img src="../../../assets/icons/select-down.svg" alt="select-down" />
                                </button>
                                {
                                    showDropDown
                                    ? 
                                        <ul className="absolute z-30 bg-white shadow-md rounded-md top-10 right-0 w-full">
                                            {visitTypeList.map((visit, index) => (
                                                <li key={`visit${index}`} onClick={(e) => handleDropDown((e), visit)}  className="bg-white hover:bg-action-hover py-1 sm:py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize text-sm">{ visit.Title }</li>
                                            ))}
                                        </ul>                            
                                    : null
                                }
                            </div>
                        </div>
                        <form onSubmit={(e) => handleSubmit(e)}>
                            <div className="flex justify-end items-center space-x-4 mt-4 sm:mt-0">
                                <button onClick={(e) => (!isButtonLoading && hangleModalClose(e))} type="button" className="text-center px-2 sm:px-4 text-xs font-medium sm:text-base py-2 text-blue-normal bg-white border border-blue-normal rounded-lg tracking-wide capitalize">{ t('go back') }</button>
                                {!isButtonLoading 
                                ? 
                                    <button type={visitType ? "submit" : "button"} className={(visitType ? "bg-blue-normal border border-blue-normal " : "text-white border-blue-disable cursor-not-allowed bg-blue-disable") + " text-center px-2 sm:px-4 text-xs font-medium sm:text-base py-2 text-white rounded-lg tracking-wide capitalize"}>{ t('start visit') }</button>
                                :
                                    <button type="button" className="text-white bg-blue-normal border-blue-normal text-center px-2 sm:px-4 text-xs font-medium sm:text-base py-2 border rounded-lg tracking-wide capitalize cursor-wait">{t('Please wait, in-progress')}</button>
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SchedulePopUp;